import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/hero-background.webp"
          alt="Rafael M&C Constructions interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-20 md:pt-24">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs md:text-sm font-medium tracking-wider uppercase mb-6 md:mb-8">
            Family-Owned &bull; Licensed &bull; Insured
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
            Building Dreams
            <br />
            <span className="text-primary-400">With Quality</span> You Can Trust
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mb-8 md:mb-10 leading-relaxed">
            Rafael M&C Constructions LLC delivers premium general contracting, remodeling, and plumbing services across Virginia, Maryland, and Washington D.C. With over 10 years of experience, we turn your vision into reality.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Get Your Free Estimate
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
            </Link>
            <Link
              to="/projects"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-transparent border border-background-50/30 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              View Our Work
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
            </Link>
          </div>

          <div className="mt-14 md:mt-20 grid grid-cols-3 gap-4 md:gap-6 w-full max-w-2xl">
            {[
              { icon: 'ri-shield-check-line', label: 'Fully Licensed' },
              { icon: 'ri-time-line', label: '10+ Years Exp.' },
              { icon: 'ri-star-line', label: '5-Star Service' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50/8 backdrop-blur-sm border border-background-50/10">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                  <i className={`${item.icon} text-2xl md:text-3xl text-primary-400`}></i>
                </div>
                <span className="text-xs md:text-sm text-background-50/80 font-medium whitespace-nowrap">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-background-50/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2.5 rounded-full bg-background-50/60"></div>
        </div>
      </div>
    </section>
  );
}